import { FC, useCallback, useState } from 'react';
import cx from 'classnames';
import { SvgIcon } from '@/components/SvgIcon';
import { useTranslation } from 'react-i18next';
import CompareTariffsTable from './components/CompareTariffsTable/CompareTariffsTable';
import styles from './CompareTariffs.module.sass';

interface CompareTariffsProps {
  isExpanded?: boolean;
  onToggle?: () => void;
}

const CompareTariffs: FC<CompareTariffsProps> = ({ isExpanded, onToggle }) => {
  const { t } = useTranslation();

  const handleToggle = useCallback(() => {
    onToggle?.();
  }, [onToggle]);

  const classes = cx(styles.toggle, {
    [styles.expanded]: isExpanded,
  });

  return (
    <div className={styles.table}>
      <div className={styles.header}>
        <button type="button" className={classes} onClick={handleToggle}>
          <span>{t('translation.compare_plan_features_title')}</span>
          <SvgIcon name="arrow-down-short" className={styles.arrow} />
        </button>
      </div>

      {isExpanded && <CompareTariffsTable />}
    </div>
  );
};

export default CompareTariffs;
